<cw-ci-data-table #assessmentTemplateDataTable
  tileTitle="Assessment Templates"
  addToolTip="Create a new assessment"
  refreshToolTip="Reload assessment list"
  defaultSortField="assessment_name"
  [isSelectable]="isSelectable"
  (loadItemsHandler)="loadAssessmentTemplates($event)"
  (addHandler)="addAssessmentTemplate($event)"
  (selectHandler)="editAssessmentTemplate($event)"
  [items]="assessmentTemplateList">

  <cw-ci-table-column columnName="name" columnTitle="Name" sortField="assessment_name"></cw-ci-table-column>
  <cw-ci-table-column columnName="type" columnTitle="Type"></cw-ci-table-column>

  <cw-ci-table-column columnName="updatedAt" columnTitle="Updated" sortField="updated_at" [output]="updatedAtTemplate"></cw-ci-table-column>
  <ng-template let-element #updatedAtTemplate>{{element.updatedAt | date:'mediumDate':'+0000'}}</ng-template>

  <cw-ci-table-column columnName="actions" columnTitle="Actions" [output]="actionTemplate"></cw-ci-table-column>
  <ng-template let-element #actionTemplate>
    <cw-ci-table-column-action actionToolTip="Edit the assessment" svgIcon="cw:action_edit" actionColor="primary" [element]="element" (clickHandler)="editAssessmentTemplate($event)"></cw-ci-table-column-action>
    <cw-ci-table-column-action actionToolTip="Delete the assessment" matIcon="delete_forever" actionColor="warn" [element]="element" (clickHandler)="deleteAssessmentTemplate($event)"></cw-ci-table-column-action>
  </ng-template>

</cw-ci-data-table>